import type { IUserRepository } from "@src/domain/users/repository/user.repository.interface";
import type { UserDTO } from "../dto/user.dto";
import { UserDtoMapper } from "../mappers/user-dto.mapper";

/**
 * Use Case: Get User By ID
 * Fetches a specific user by their ID (Admin only)
 */
export class GetUserByIdUseCase {
    constructor(private readonly userRepository: IUserRepository) { }

    /**
     * Execute the use case
     * @param userId - User ID
     * @returns Promise<UserDTO | null> - User DTO if found, null otherwise
     * @throws Error if userId is invalid
     */
    async execute(userId: string): Promise<UserDTO | null> {
        if (!userId || !userId.trim()) {
            throw new Error('User ID is required');
        }

        const user = await this.userRepository.getById(userId);
        return user ? UserDtoMapper.toDTO(user) : null;
    }
}
